<template>
    <b-dropdown id="dropdown-1" :text="currentStatusText" class="m-md-2">
        <b-dropdown-item v-if="osce.status != 1" @click="openDialog('active')">{{ $t('active') }}</b-dropdown-item>
        <b-dropdown-item v-if="osce.status != 2" @click="openDialog('disable')">{{ $t('disable') }}</b-dropdown-item>
        <b-dropdown-item v-if="osce.status != 3" @click="openDialog('delete')">{{ $t('delete') }}</b-dropdown-item>
    </b-dropdown>
</template>
<script>
export default {
    props: {
        osce: Object
    },
    methods: {
        openDialog(action) {

            var self = this;
            this.$store.commit('openDialog', {
                title: this.$t('are-you-sure'),
                content: this.$t(`${action}-{e}-warning`, { e: this.$t('osce') }),
                cancelBtn: true,
                confirmCallBack: function () {
                    self.handleOSCE(action)
                }
            })
        },
        handleOSCE(action) {

            if (action === 'active') this.osce.status = 1;
            if (action === 'disable') this.osce.status = 2;
            if (action === 'delete') this.osce.status = 3;

            this.$store.commit('showBlockingSpinner');

            this.$cfetch(`${this.$settings.APIBaseURL}/osce/save`, {
                method: 'POST',
                data: this.osce,

            }).then(res => {
                if (res.status !== 'SUCCESS') throw new Error('Unexpected error ')

                this.$store.commit('hideBlockingSpinner');
                this.$router.replace("/settings/osce")

            }).catch(err => {
                this.$log.error.call(this, err)
                this.$store.commit('openDialog', {
                    title: this.$t('something-went-wrong'),
                    content: this.$t(`error-${action}-{e}`, { e: this.$t('osce') }),
                })
            })
        }
    },
    computed: {
        currentStatusText() {
            if (this.osce.status == 1) return this.$t('active');
            if (this.osce.status == 2) return this.$t('disabled');
            if (this.osce.status == 3) return this.$t('deleted');
            return ''
        }
    }
}
</script>